// removed by extract-text-webpack-plugin
module.exports = {"docs":"Ff2K5Jo_zh60p4YdpK2e4","list":"_1N5b0DiuAEk0yg2_o6zue_","flag":"_29xQnMoJfWA9wi5oVisqNq","borderBottom":"_37G9YOfAhvxEF5rPWvGR80","docsInner":"_2OolBP_8kkwTyolE1ZCalt"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Docs/style.css
// module id = 673
// module chunks = 0